import styled from '@emotion/styled';
import { forTabletLandscapeDown, Variables } from '../base';

export const AppShellLayout = styled.main<{ sidebarOpened: boolean; sidebarRail?: boolean; topNavCollapsed?: boolean }>`
    display: flex;
    flex-direction: column;
    height: 100vh;
    max-height: 100vh;
    margin-left: ${({ sidebarOpened, sidebarRail }) =>
        sidebarOpened ? Variables.sidebarSize : sidebarRail ? Variables.sidebarRailSize : 'unset'};
    padding-top: ${({ topNavCollapsed }) => (topNavCollapsed ? 0 : Variables.topnavSize)};
    color: ${Variables.Colors.p500};
    background-color: ${Variables.Colors.sidebarBackground};
    z-index: 1;
    overflow: auto;
    transition: margin 225ms cubic-bezier(0, 0, 0.2, 1) 0ms;

    /* Below the breakpoint an open sidebar overlays the page; only the rail keeps its space. */
    ${({ sidebarRail }) =>
        forTabletLandscapeDown(`
        margin-left: ${sidebarRail ? Variables.sidebarRailSize : 0};
        width: initial;
        height: 100vh;
        max-height: 100vh;
    `)};
`;
